export default class AText extends Phaser.GameObjects.Text
{
    /**
     * @param {Phaser.Scene} scene 
     * @param {Phaser.GameObjects.Container} parent 
     */
    constructor(scene, x, y, textSize, hexColor, font, text, wordWrapWidth)
    {
        let colUtils = Phaser.Display.Color;
        let color = colUtils.ValueToColor(hexColor);
        

        super(scene, x, y, text, {
            fontFamily: font,
            fontSize: textSize,
            color: colUtils.RGBToString(color.red, color.green, color.blue, color.alpha),
            wordWrap: {width:wordWrapWidth, useAdvancedWrap:true},
            startSize: textSize
        });
    }

    setShadow(x, y, color, blurAmount = 0)
    {
        let colUtils = Phaser.Display.Color;
        let pCol = colUtils.ValueToColor(color);
        let newColor = colUtils.RGBToString(pCol.red, pCol.green, pCol.blue);

        super.setPadding(x + blurAmount, y + blurAmount);
        super.setShadow(x, y, newColor, blurAmount);
    }

    setBold()
    {
        this.setFontStyle('bold');
    }
    

    resizeFont(txt, maxWidth, startSize)
    {
        //console.log(txt, this.width, startSize, this.text);
        let newSize = startSize;

        while(this.width > maxWidth) {
            newSize--;
            //console.log(this.style.fontSize, newSize);

            if(newSize <= 10){
                return;
            } 
            else {
                //this.text = txt;
                console.log(txt, this.width, startSize, this.text);
                this.style.setFontSize(newSize.toString() + "px");
            }
        }

        this.text += txt;
        console.log(txt, this.width, startSize, this.text);
        //this.style.setFontSize(newSize.toString() + "px");
    }
}